import React, { createContext, useState } from 'react';

// Create the context
export const AppContext = createContext();

// Create the context provider component
export const AppContextProvider = ({ children }) => {
  const [applang, setApplang] = useState('en');
  
  // Define text size multipliers for different languages
  const languageSizes = {
    'en': 1,        // English (default)
    'de': 1.1,      // German (slightly larger for longer words)
    'ar': 1.3,     // Arabic
    'zh': 0.9,      // Chinese (can be smaller due to character density)
    'ja': 0.9,      // Japanese
    'ru': 1.1,      // Russian
    'hi': 1.05,     // Hindi
    'fr': 1.05      // French
  };

  // Get text size multiplier based on current language
  const getTextSizeMultiplier = () => {
    return languageSizes[applang] || 1; // default to 1 if language not found
  };

  return (
    <AppContext.Provider value={{ 
      applang, 
      setApplang,
      getTextSizeMultiplier 
    }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;